import ProjectFile from "@/models/entities/ProjectFile";
import {chunkSize} from "@/AppConfig";
import {Block} from "@/models/helpers/Block";

export class UploadSession {
    uploadGuid:string;
    ticketGuid:string|null;
    sendBlockIndexes:Array<number>;
    fileName:string;
    fileHash:string;
    initalBlockCount:number;

    constructor(file:ProjectFile, fileHash:string, ticketGuid:string|null=null) {
        this.uploadGuid = file.downloadToken;
        this.ticketGuid = ticketGuid;
        this.initalBlockCount = Math.ceil(file.sizeInBytes/chunkSize);
        this.fileName = file.name;
        this.fileHash = fileHash;
        this.sendBlockIndexes = new Array<number>();
    }
}

export const generateBlocksFromFile = (uploadGuid: string, initalBlockCount:number, file:File):Array<Block> => {
    const genratedBlocks = new Array<Block>();

    for (let i = 0; i < initalBlockCount; i++) {
        const start = i * chunkSize
        const end = Math.min(start + chunkSize, file.size)
        const blockBlob = file.slice(start, end, file.type)
        genratedBlocks.push(new Block(i, new File([blockBlob], `${uploadGuid}-${i}`, {type: file.type})));
    }

    return genratedBlocks;
}